import { Flex, Center, Button, Box, Avatar } from '@chakra-ui/react';
import { NotificationCard } from '../../components/Card';
import { NotificationTime } from '../../components/Time';
import { decode } from 'js-base64';
import { Phone } from '@kula-ai/icons-core';
import { CollapsibleSection } from '../referral-notifications/components';
import { KText } from '@/ui-library/components';
import { useHistory } from 'react-router-dom';
import { CREDIT_MANAGEMENT_PATH } from '@/components/ats/actions/background-check/backgroundCheckApi';
import { useKFlags } from '@/hooks/use-k-flags';
import { COORDINATOR_CREDIT_NOTIFICATION_COPY } from './constants';

// Admin-facing "AI coordinator credit cap reached" notification (type 119),
// emitted when a recruiter uses "Notify admin". Mirrors the fraud-detector
// credit notification with coordinator copy.
const CoordinatorCredit = ({ notification = {} }) => {
  const history = useHistory();
  const { tUnifiedCreditManagement } = useKFlags();
  const { custom_attributes } = notification;

  const handleCta = () => {
    if (tUnifiedCreditManagement) {
      history.push(CREDIT_MANAGEMENT_PATH);
    } else {
      (window as unknown as { Pylon?: (_cmd: string) => void }).Pylon?.('show');
    }
  };

  let requestedBy = null;
  try {
    const data = JSON.parse(decode(custom_attributes));
    requestedBy = data?.requested_by;
  } catch {
    // ignore decode errors
  }

  return (
    <Flex alignItems="baseline" gap="6px">
      <Center
        minW="34px"
        h="34px"
        borderRadius="sm"
        bg="primary-100"
        flexShrink={0}
      >
        <Phone
          size={16}
          color="var(--kula-colors-primary-500)"
          className="kula-icon"
        />
      </Center>
      <Flex flexDir="column" ml="16px" gap="8px" alignSelf="start" flex="1">
        <KText fontWeight="semiBold">
          {COORDINATOR_CREDIT_NOTIFICATION_COPY.title}
        </KText>

        <CollapsibleSection
          title={COORDINATOR_CREDIT_NOTIFICATION_COPY.detailsTitle}
        >
          <Box p="12px 16px">
            <KText color="secondary-700" mb="8px">
              {COORDINATOR_CREDIT_NOTIFICATION_COPY.body}
            </KText>
            {requestedBy?.name && (
              <Flex alignItems="center" gap="6px">
                <KText fontWeight="semiBold" color="secondary-900">
                  {COORDINATOR_CREDIT_NOTIFICATION_COPY.requestedByLabel}
                </KText>
                <Avatar
                  size="2xs"
                  borderRadius="4px"
                  src={requestedBy.avatar_url}
                  name={requestedBy.name}
                />
                <KText color="secondary-700">{requestedBy.name}</KText>
              </Flex>
            )}
          </Box>
        </CollapsibleSection>

        <NotificationTime notification={notification} />

        <Button variant="primary" size="sm" w="fit-content" onClick={handleCta}>
          {tUnifiedCreditManagement
            ? COORDINATOR_CREDIT_NOTIFICATION_COPY.topUpCta
            : COORDINATOR_CREDIT_NOTIFICATION_COPY.supportCta}
        </Button>
      </Flex>
    </Flex>
  );
};

export const CoordinatorCreditNotification = ({
  notification = {},
  onClose = () => {},
}) => {
  return (
    <NotificationCard notification={notification}>
      <CoordinatorCredit notification={notification} onClose={onClose} />
    </NotificationCard>
  );
};
